import { render } from "./create-article.vue?vue&type=template&id=53bb391b&ts=true"
import script from "./create-article.vue?vue&type=script&lang=ts"
export * from "./create-article.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__